"use client";

import { cn } from "@/lib/utils";

const OrderDetailsLoader = () => {
  return (
    <article className={cn("text-dark-primary flex-1/2 animate-pulse space-y-10")}>
      {/* Order Details Card */}
      <section className="space-y-5">
        <div className="h-8 w-1/3 rounded bg-gray-200" />
        <div className="border-primary-light/50 space-y-3 rounded-md border p-4">
          <div className="h-5 w-1/2 rounded bg-gray-200" />
          <div className="h-5 w-1/3 rounded bg-gray-200" />
        </div>

        <div className="h-8 w-1/3 rounded bg-gray-200" />
        <div className="border-primary-light/30 grid grid-cols-1 gap-7.5 rounded-md border p-4 md:grid-cols-2">
          <div className="space-y-3">
            <div className="h-5 w-2/3 rounded bg-gray-200" />
            <div className="h-5 w-1/2 rounded bg-gray-200" />
            <div className="h-5 w-1/2 rounded bg-gray-200" />
          </div>
          <div className="space-y-3">
            <div className="h-5 w-2/3 rounded bg-gray-200" />
            <div className="h-5 w-1/2 rounded bg-gray-200" />
            <div className="h-5 w-1/2 rounded bg-gray-200" />
          </div>
        </div>
      </section>

      {/* Order Summary Section */}
      <section className="flex flex-col gap-5">
        <div className="h-8 w-1/3 rounded bg-gray-200" />

        {/* Product List */}
        <ul className="space-y-[13px]">
          {[...Array(2)].map((_, index) => (
            <li key={index} className="flex items-center gap-5.5">
              <div className="size-[74px] shrink-0 rounded-md bg-gray-200" />
              <div className="flex w-full flex-col gap-3">
                <div className="h-5 w-1/3 rounded bg-gray-200" />
                <div className="h-4 w-1/4 rounded bg-gray-200" />
              </div>
              <div className="flex flex-col items-end gap-2">
                <div className="h-5 w-16 rounded bg-gray-200" />
                <div className="h-4 w-10 rounded bg-gray-200" />
              </div>
            </li>
          ))}
        </ul>

        {/* Footer */}
        <dl className="border-primary-light/50 space-y-4 border-t pt-5">
          <div className="flex items-center justify-between">
            <dd className="h-5 w-1/4 rounded bg-gray-200" />
            <dt className="h-5 w-16 rounded bg-gray-200" />
          </div>
          <div className="flex items-center justify-between">
            <dd className="h-5 w-1/4 rounded bg-gray-200" />
            <dt className="h-5 w-16 rounded bg-gray-200" />
          </div>
          <hr className="border-primary-light/50 my-5" />
          <div className="flex items-start justify-between">
            <dd className="space-y-1">
              <div className="h-5 w-1/4 rounded bg-gray-200" />
              <div className="h-3 w-1/3 rounded bg-gray-200" />
            </dd>
            <dt className="h-6 w-20 rounded bg-gray-200" />
          </div>
        </dl>

        {/* Button */}
        <div className="h-11 w-40 rounded bg-gray-200" />
      </section>
    </article>
  );
};

export default OrderDetailsLoader;
